"use strict";

var ISurveyComponent = require("../Api/ISurveyComponent");
var InterceptComponent = /** @class */function () {
  function InterceptComponent(data) {
    if (!data) {
      throw new Error("data must not be null");
    }
    if (!data.question) {
      throw new Error("data.question must not be null or empty");
    }
    if (!data.title) {
      throw new Error("data.title must not be null or empty");
    }
    if (!data.url) {
      throw new Error("data.url must not be null or empty");
    }
    this.data = data;
  }
  InterceptComponent.make = function (data) {
    try {
      return new InterceptComponent(data);
    } catch (e) {
      return null;
    }
  };
  // @Override
  InterceptComponent.prototype.getType = function () {
    return "Intercept" /* Intercept */;
  };
  // @Override
  InterceptComponent.prototype.getTitle = function () {
    return this.data.title;
  };
  // @Override
  InterceptComponent.prototype.getQuestion = function () {
    return this.data.question;
  };
  // @Override
  InterceptComponent.prototype.getUrl = function () {
    return this.data.url;
  };
  // @Override
  InterceptComponent.prototype.getDomElements = function (doc) {
    if (!doc) {
      throw new Error("Document must not be null");
    }
    return [doc.createElement(ISurveyComponent.DOM_INTERCEPT_TAGNAME)];
  };
  // @Override
  InterceptComponent.prototype.getJsonElements = function () {
    var _a;
    return _a = {}, _a[ISurveyComponent.JSON_INTERCEPT_KEYNAME] = "", _a;
  };
  // @Override
  InterceptComponent.prototype.getComponentJson = function () {
    var _a;
    return _a = {}, _a[ISurveyComponent.JSON_TITLE_KEYNAME] = this.getTitle(), _a[ISurveyComponent.JSON_QUESTION_KEYNAME] = this.getQuestion(), _a[ISurveyComponent.JSON_INTERCEPTURL_KEYNAME] = this.getUrl(), _a;
  };
  return InterceptComponent;
}();
(function (InterceptComponent) {
  var InterceptComponentData = /** @class */function () {
    function InterceptComponentData() {}
    return InterceptComponentData;
  }();
  InterceptComponent.InterceptComponentData = InterceptComponentData;
})(InterceptComponent || (InterceptComponent = {}));
module.exports = InterceptComponent;